import { DesignProp, GeneralProp } from "../PropCategories";

export const lineHeight = {
  prop: "style-attribute",
  name: "Line Height",
  nameI18n: "builder_ui.prop_type.styles.line_height",
  category: [DesignProp, GeneralProp],
  type: "number",
  defaultValue: "1.5",
  numberProps: {
    min: 0,
    max: 5,
    step: 0.1,
  },
} as const;
